module.exports = {"id":"213591","name":"Juan Cornejo","rating":"71","photo":"./data/images/photos/2/213591.png","club":{"name":"León","logo":"./data/images/clubs/Leon.png"},"positions":["DG","DC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JuanCornejo0.json
// module id = 2207
// module chunks = 0